import { useState } from "react";
import { copy, ORDER_STATUSES } from "@wheels-crm/shared-types";
import type { OrderStatus, RejectReason } from "@wheels-crm/shared-types";
import { Select } from "../ui/Select";
import { RejectReasonModal } from "./RejectReasonModal";

/**
 * Inline status dropdown embedded in each orders-table row (§6.3). Selecting "Відмова"
 * opens a confirmation modal for the reject reason BEFORE committing — cancelling reverts
 * the dropdown to its previous value (§6.4).
 */
export function StatusSelect({
  value,
  onChange,
}: {
  value: OrderStatus;
  onChange: (status: OrderStatus, rejectReason?: RejectReason) => void;
}) {
  const [pendingReject, setPendingReject] = useState(false);

  function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const next = e.target.value as OrderStatus;
    if (next === "rejected") {
      setPendingReject(true);
      return;
    }
    onChange(next);
  }

  return (
    <>
      <Select value={value} onChange={handleChange} onClick={(e) => e.stopPropagation()}>
        {ORDER_STATUSES.map((s) => (
          <option key={s} value={s}>
            {copy.orderStatus[s]}
          </option>
        ))}
      </Select>
      {pendingReject && (
        <RejectReasonModal
          onConfirm={(reason) => {
            setPendingReject(false);
            onChange("rejected", reason);
          }}
          onCancel={() => setPendingReject(false)}
        />
      )}
    </>
  );
}
